module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/contact-phone-icon.e52b55d6.svg";